/**
 * Motivos categorizados para crear una nueva versión de plan de pagos.
 * Espejo de Finance.Shared.Enums.PaymentPlanVersionReason en backend.
 */
export enum PaymentPlanVersionReason {
  Initial = 0,
  Refinance = 1,
  Withdrawal = 2,
  Deferral = 3,
  Reversal = 4,
  Adjustment = 5,
  AdminFix = 6,
}

export const PaymentPlanVersionReasonLabels: Record<PaymentPlanVersionReason, string> = {
  [PaymentPlanVersionReason.Initial]: 'Plan inicial',
  [PaymentPlanVersionReason.Refinance]: 'Refinanciamiento',
  [PaymentPlanVersionReason.Withdrawal]: 'Retiro de cartera',
  [PaymentPlanVersionReason.Deferral]: 'Aplazamiento',
  [PaymentPlanVersionReason.Reversal]: 'Reversión',
  [PaymentPlanVersionReason.Adjustment]: 'Ajuste manual',
  [PaymentPlanVersionReason.AdminFix]: 'Reparación admin (rescate de huérfanas)',
};

export const EditablePaymentPlanVersionReasons: PaymentPlanVersionReason[] = [
  PaymentPlanVersionReason.Refinance,
  PaymentPlanVersionReason.Adjustment,
];
